import Vue from 'vue';

Vue.component('supplier-index', () =>
    import(/* webpackChunkName: 'supplier-index' */ './supplier-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/franchise-inventory/supplier/index.js